import type {ReactElement} from 'react';
import {getDefaultDisplayURL, swapToDefaultDisplayURL} from '@Components/social-media/account.vo';
import {assertNever} from '@Utils/assert-never.util';
import type {PreviewAvatarProps} from './preview-avatar.types';
import {PreviewAvatarShape} from './preview-avatar.types';
import styles from './preview-avatar.module.scss';

export function PreviewAvatar({account, className = '', shape = PreviewAvatarShape.CIRCLE}: PreviewAvatarProps): ReactElement {
  const getShapeClassName = (): string => {
    switch (shape) {
      case PreviewAvatarShape.CIRCLE:
        return styles.previewAvatarCircle;
      case PreviewAvatarShape.ROUNDED_SQUARE:
        return styles.previewAvatarRoundedSquare;
      default:
        return assertNever(shape);
    }
  };

  return (
    <img
      alt=""
      aria-hidden="true"
      className={`${styles.previewAvatar} ${getShapeClassName()} ${className}`}
      onError={swapToDefaultDisplayURL}
      src={account.displayURL ?? getDefaultDisplayURL()}
    />
  );
}
